const WISSEN = 'wissen';
const BILDUNG = 'bildung';
const NEWS = 'goodnews';
export const MENU_DESCRIPTION = {
  [WISSEN]: `Wissenswertes zum Thema nachhaltige Gesundheit, gesunde Lebenswelten und Lebensweisen, betriebliches Gesundheitsmanagement (BGM), betriebliche Gesundheitsförderung (BGF) und Public Health.
    Schwerpunktthemen sind Informationen über Ernährung, Gesundheitssport, Mentale Gesundheit und Sucht aus der Gesundheitswirtschaft, der Gesundheitspolitik, der Wissenschaft, der Technik, der Kunst und des Reisens, sowie aus regionalen und überregionalen Gesundheitsprojekten.`,
  [BILDUNG]: `Gesundheitstipps für körperliche, geistige und seelische Gesundheit, betriebliche Gesundheitsförderung (BGF) und Public Health.`,
  [NEWS]: `Gesundheitsnews und interessante Neuigkeiten zu allen Gesundheitsthemen und aus unseren Partnernetzwerken.`,
};
export const ANGEBOTE_DESCRIPTION = `Angebote der Partner des GesundheitsTicket-Netzwerks und anderer Vertriebspartner (nicht nur) für GesundheitsTicket-InhaberInnen.`;
export const RG_DESCRIPTION = `RegioHealth.News ist eine Plattform für Informationen und Neuigkeiten rund um regionale und überregionale Gesundheitsthemen der Partner des GesundheitsTicket-Netzwerks.
Die Idee für RegioHealth.News entstand aus dem Wunsch einer besseren Vernetzung der Kunden und GesundheitsPartnern des Netzwerks der GesundheitsTicket GmbH mit der Möglichkeit, über Projekte und Aktionen und Angebote zu publizieren, um sie der Öffentlichkeit aber auch konkreten Zielgruppen wie GesundheitsTicket-Inhabern zugänglich zu machen.
Darüber hinaus veröffentlicht die Plattform auch Informationen rund um Aktivitäten und Projekte unserer Unternehmensgruppe und stellt allgemein interessante Informationen zum Thema Gesundheit und gesunde Lebenswelten zur Verfügung.
Damit ist RegioHealth.News auch eine geeignete Informationsquelle für Unternehmen, Kommunen, Gesundheitsregionen, GesundheitsmanagerInnen, PersonalleiterInnen und alle an Gesundheitsthemen interessierte Menschen.`;
export const RG_LOGO =
  'https://www.regio-health.de/cms/wp-content/uploads/2020/10/regiohealth-news.svg';
export const EVENTS_CALENDAR_PATTERN = '[calendar]';
export const IFRAME_PATTERN = '[iframe]';
export const ARTICLE_HEIGHT = 244.52;
export const ARTICLES_LIMIT = 14;

export const EVENT_TICKET_TYPES = Object.freeze({
  GT: 'GT',
  GT_PLUS: 'GT Plus',
});

export const I18N_STORAGE_KEY = 'i18nextLng';

export const SIDEBAR_ARTICLES_CATEGORIES = Object.freeze({
  OFFERS: 'angebote',
  EDUCATION: 'bildung',
  HEALTH_COMMUNITY: 'gesundekommune',
  PROJECTS: 'projekte',
  GOOD_NEWS: 'goodnews',
  KNOWLEDGE: 'wissen',
});
